import React, { Component } from "react";
import { connect } from "react-redux";
import { nextQuestion } from "./../actions/assessment";
import imgTimeExpired from "./../assets/img/illus-success.svg";

import { Translate } from "react-redux-i18n";

export class TimeExpired extends Component {
    handleContinue = () => {
        this.props.nextQuestion();
    };

    render() {
        const i18n = require('react-redux-i18n').I18n;

        return (
            <div className="main container-fluid mt-nav p-0">
                <div className="d-md-flex">
                    <div className="col col-main">
                        <div className="card test-alert card-body  justify-content-center">
                            <div className="inner">
                                <img src={imgTimeExpired} height="150" alt={i18n.t("expired")} />
                                <h1 className="title"><Translate value="time_exp" /></h1>
                                <p>
                                    <Translate value="time_p1" />
                                </p>
                                <div className="button-wrap mt-md-5">
                                    <button
                                        onClick={this.handleContinue}
                                        className="btn btn-outline-gray btn-global ord-2"
                                    >
                                        <Translate value="cont" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    nextQuestion: (next_scale = false) => dispatch(nextQuestion(next_scale))
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeExpired);
